/* eslint-disable react-hooks/rules-of-hooks */
import i18n from 'i18next';

// Removed useTranslation import as it cannot be used at the top level
import * as yup from 'yup';

// Removed useTranslation hook usage; using i18n.t directly instead

/**
 * Factory function for creating Yup string schemas with translations
 * @returns A custom string schema builder with translated validation messages
 */
export const createStringSchema = () => {
  // Removed useTranslation hook usage; using i18n.t directly instead
  return {
    /**
     * Create a required string field with translated error message
     * @returns Yup string schema with required validation
     */
    required: (): yup.StringSchema => {
      return yup.string().required(i18n.t("validation.required"));
    },

    /**
     * Create a required email field with translated error messages
     * @returns Yup string schema with required and email validation
     */
    requiredEmail: (): yup.StringSchema => {
      return yup.string()
        .required(i18n.t('validation.required'))
        .email(i18n.t('validation.invalidEmail'));
    },

    /**
     * Create an optional email field with translated error message
     * @returns Yup string schema with email validation
     */
    optionalEmail: (): yup.StringSchema => {
      return yup.string().email(i18n.t('validation.invalidEmail'));
    },

    /**
     * Create a required phone field with translated error messages
     * @param regex Regular expression for phone validation
     * @returns Yup string schema with required and phone validation
     */
    requiredPhone: (regex: RegExp): yup.StringSchema => {
      return yup.string()
        .required(i18n.t('validation.required'))
        .matches(regex, i18n.t('validation.invalidPhone'));
    },

    /**
     * Create an optional phone field with translated error message
     * @param regex Regular expression for phone validation
     * @returns Yup string schema with phone validation
     */
    optionalPhone: (regex: RegExp): yup.StringSchema => {

      return yup.string().test({
        name: 'phone',
        test: (value) => {
          if (!value) {
            // Skip validation if value is empty or undefined
            return true;
          }
          // Run matches validation if value is not empty or undefined
          return regex.test(value);
        },
        message: () => i18n.t("validation.invalidPhone")
      });
    }
  };
}; 